var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        "z-index": "999999 !important",
        "background-color": "#ffffff",
      },
    },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            label: _vm.$t("trajectory.trackingUpdateAlert"),
            "show-close": false,
            visible: _vm.trajectoryDialog,
            top: "10vh",
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.trajectoryDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "center" } },
            [
              _c("div", [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { "font-size": "25px", color: "red" },
                }),
              ]),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-left": "8px",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "16px",
                        "font-weight": "bold",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("trajectory.customerTrackingAlert")) +
                          " "
                      ),
                    ]
                  ),
                  _c("div", [
                    _vm._v(_vm._s(_vm.$t("trajectory.penaltyWarning"))),
                  ]),
                ]
              ),
            ]
          ),
          _c(
            "el-table",
            {
              ref: "tableRef",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                border: "",
                height: "420",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("trajectory.customer"),
                  align: "center",
                  "min-width": "180",
                  prop: "customerName",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.NumberPackages"),
                  align: "center",
                  "min-width": "100",
                  prop: "orderCount",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.toHandleFun(1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("trajectory.acknowledgeClose")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.toHandleFun(2)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("trajectory.handleImmediately")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }